// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.termination.LeaseTerminationWebApiHandler

import type { UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  LeaseTerminationWebApiHandler_getTerminationReasons,
  LeaseTerminationWebApiHandler_getTerminationReasons_Path,
  LeaseTerminationWebApiHandler_terminateLease,
} from '@zg-rentals/ts-leasing-client';

import type { GetTerminationReasonsResponseDto, TerminateLeaseRequestDto } from '@zg-rentals/ts-leasing-client';

export type LeaseTerminationWebApiHandler_getTerminationReasons_Options = UseQueryOptions<
  GetTerminationReasonsResponseDto,
  unknown,
  GetTerminationReasonsResponseDto,
  Array<string>
>;

const LeaseTerminationWebApiHandler_getTerminationReasons_GetKey = () => [
  LeaseTerminationWebApiHandler_getTerminationReasons_Path,
];

/**
 * get termination reasons
 */
export const useLeaseTerminationWebApiHandler_getTerminationReasons = ({
  httpClient,
  ...options
}: Omit<LeaseTerminationWebApiHandler_getTerminationReasons_Options, 'queryFn' | 'queryKey'> & {
  httpClient?: Client;
} = {}) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: LeaseTerminationWebApiHandler_getTerminationReasons_GetKey(),
    queryFn: () => LeaseTerminationWebApiHandler_getTerminationReasons(httpClient),
  });
};
useLeaseTerminationWebApiHandler_getTerminationReasons.getKey =
  LeaseTerminationWebApiHandler_getTerminationReasons_GetKey;

export interface LeaseTerminationWebApiHandler_terminateLease_Args {
  postData: TerminateLeaseRequestDto;
}

export type LeaseTerminationWebApiHandler_terminateLease_Options = UseMutationOptions<
  void,
  unknown,
  LeaseTerminationWebApiHandler_terminateLease_Args
>;

/**
 * terminate active lease
 */
export const useLeaseTerminationWebApiHandler_terminateLease = ({
  httpClient,
  ...options
}: Omit<LeaseTerminationWebApiHandler_terminateLease_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: LeaseTerminationWebApiHandler_terminateLease_Args) =>
      LeaseTerminationWebApiHandler_terminateLease(args.postData, httpClient),
  });
};
